import React, {Component} from 'react';
import star from '../img/star.png';
import stock from '../img/stok.png'

class Hero extends Component {
    render() {
        return (
            <div className="row Hero">
                <div className="col-lg-6 hero_pic wow fadeIn">
                    {(this.props.picUrl == null) || (this.props.picUrl === '') ?
                        <img src={stock} alt=""/> :
                        <img src={this.props.picUrl} alt=""/>
                    }
                </div>
                <div className="col-lg-6 hero_info wow zoomIn">
                    <h2>{this.props.name}</h2>
                    <div className="stars">
                        <img src={star} alt=""/>
                        <div className="stars_txt">
                            <h5>{this.props.rank}</h5>
                            <h6>{this.props.lifeTime}</h6>
                        </div>
                    </div>
                    <p>{this.props.information}</p>
                </div>
            </div>
        );
    }
}

export default Hero;